/**
Copyright 2021 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
export const LOAD_SOCIAL_BOARD = "LOAD_SOCIAL_BOARD";
export const LOAD_SOCIAL_BOARDS = "LOAD_SOCIAL_BOARDS";
export const LOAD_SOCIAL_POST = "LOAD_SOCIAL_BOARD";
export const PAGINATE_SOCIAL_BOARDS = "PAGINATE_SOCIAL_BOARDS";
export const PAGINATION_START_SOCIAL_BOARDS = "PAGINATION_START_SOCIAL_BOARDS";
export const CHANGE_SOCIAL_TAB = "CHANGES_SOCIAL_TAB";
export const CREATE_POST = "CREATE_POST";
export const OPEN_BOARD_OPTIONS = "OPEN_BOARD_OPTIONS";
export const CLOSE_BOARD_OPTIONS = "CLOSE_BOARD_OPTIONS";
export const LOAD_BOARD_DETAILS = "LOAD_BOARD_DETAILS";
export const SET_SELECTED_BOARD = "SET_SELECTED_BOARD";
export const PAGINATE_SOCIAL_BOARD_POSTS = "PAGINATE_SOCIAL_BOARD_POSTS";
export const PAGINATION_START_SOCIAL_BOARD_POSTS = "PAGINATION_START_SOCIAL_BOARD_POSTS";
export const OPEN_BOARDS_SELECTION = "OPEN_BOARDS_SELECTION";
export const CLOSE_BOARDS_SELECTION = "CLOSE_BOARDS_SELECTION";
export const SELECT_BOARD = "SELECT_BOARD";
export const SET_CREATEPOST_SOCIAL_SEARCH_RESULTS = "SET_CREATEPOST_SOCIAL_SEARCH_RESULTS";
export const CLEAR_SOCIAL_SEARCH_RESULTS = "CLEAR_SOCIAL_SEARCH_RESULTS";
export const SET_POST_TYPE = "SET_POST_TYPE";
export const SET_CONTENT_TYPE = "SET_CONTENT_TYPE";
export const SET_POST_TEXT = "SET_POST_TEXT";
export const REMOVE_CONTENT = "REMOVE_CONTENT";
export const CLEAR_SELECT_BOARD = "CLEAR_SELECT_BOARD";
export const ADD_USER_POLL_FOR_POST = "ADD_USER_POLL_FOR_POST";
export const UPDATE_POST = "UPDATE_POST";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const UPDATE_REPLY = "UPDATE_REPLY";
export const OPEN_POST_OPTIONS = "OPEN_POST_OPTIONS";
export const SHOW_CONFIRMATION_DIALOG = "SHOW_CONFIRMATION_DIALOG";
export const HIDE_CONFIRMATION_DIALOG = "HIDE_CONFIRMATION_DIALOG";
export const SOCIAL_BOARD_DELETE_SUCCESS = "SOCIAL_BOARD_DELETE_SUCCESS";
export const SOCIAL_POST_DELETE_SUCCESS = "SOCIAL_POST_DELETE_SUCCESS";
export const DISMISS_PANEL = "DISMISS_PANEL";
export const LOAD_COMMENTS = "LOAD_COMMENTS";
export const LOAD_REPLIES = "LOAD_REPLIES";
export const PAGINATE_REPLIES = "PAGINATE_REPLIES";
export const PAGINATION_START_REPLIES = "PAGINATION_START_REPLIES";
export const UPDATE_REPLY_TEXT = "UPDATE_REPLY_TEXT";
export const SOCIAL_ADD_BOARD_FAVORITE_SUCCESS = "SOCIAL_ADD_BOARD_FAVORITE_SUCCESS";
export const SOCIAL_REMOVE_BOARD_FAVORITE_SUCCESS = "SOCIAL_REMOVE_BOARD_FAVORITE_SUCCESS";
export const PAGINATION_START_SOCIAL_SEARCH_BOARDS = "PAGINATION_START_SOCIAL_SEARCH_BOARDS";
export const PAGINATE_SOCIAL_SEARCH_BOARDS = "PAGINATE_SOCIAL_SEARCH_BOARDS";
export const SOCIAL_REMOVE_BOARD_FROM_LIST = "SOCIAL_REMOVE_BOARD_FROM_LIST";
export const OPEN_CMT_OPTIONS = "OPEN_CMT_OPTIONS";
export const SOCIAL_CMT_DELETE_SUCCESS = "SOCIAL_CMT_DELETE_SUCCESS";
export const OPEN_REPLY_OPTIONS = "OPEN_REPLY_OPTIONS";
export const SOCIAL_REPLY_DELETE_SUCCESS = "SOCIAL_REPLY_DELETE_SUCCESS";
export const UPDATE_REPLY_VOTE_STATUS = "UPDATE_REPLY_VOTE_STATUS";
export const DELETE_REPLY_VOTE_STATUS = "DELETE_REPLY_VOTE_STATUS";
export const UPDATE_POST_PREVIEW_DATA = "UPDATE_POST_PREVIEW_DATA";
export const UPDATE_CMT_PREVIEW_DATA = "UPDATE_CMT_PREVIEW_DATA";
export const UPDATE_REPLY_PREVIEW_DATA = "UPDATE_REPLY_PREVIEW_DATA";
export const SET_SELECTED_POST = "SET_SELECTED_POST";
export const SET_SELECTED_COMMENT = "SET_SELECTED_COMMENT";
export const PAGINATE_COMMENTS = "PAGINATE_COMMENTS";
export const PAGINATION_START_COMMENTS = "PAGINATION_START_COMMENTS";
export const UPDATE_COMMENT_TEXT = "UPDATE_COMMENT_TEXT";
export const SET_BOARD_FROM_DETAILS = "SET_BOARD_FROM_DETAILS";
export const CLOSE_CREATE_POST = "CLOSE_CREATE_POST";
export const NAVIGATE_TO = "NAVIGATE_TO";
export const UPDATE_CREATEPOST_PREVIEW_DATA = "UPDATE_CREATEPOST_PREVIEW_DATA";
export const LOAD_USER_SKILLS = "LOAD_USER_SKILLS";
export const LOAD_FAV_BOARDS = "LOAD_FAV_BOARDS";